import {
  IBundle,
  ICollectionResponse,
  IRole
} from '../commonUtils/commonModels';

export interface IPermission {
  name: string;
}

export enum ENode {
  Organisation = 'Organisation',
  Unspecified = 'Unspecified',
  BusinessUnit = 'Business Unit',
  City = 'City',
  Canton = 'Canton',
  Continent = 'Continent',
  Country = 'Country',
  County = 'County',
  Location = 'Location',
  Prefecture = 'Prefecture',
  Province = 'Province',
  Region = 'Region',
  Site = 'Site',
  State = 'State',
  Territory = 'Territory'
}
export interface IExpectedAnalysisHierarchy {
  name: string;
  type: string;
  address: string;
  children: IExpectedAnalysisHierarchy[];
}
export interface INodeMetadatum {
  key: string;
  value: any;
}

export type INodeMetadataResponse = Array<INodeMetadatum>;
export interface INodeMetadata {
  id: string;
  data: INodeMetadataResponse;
}
export interface INodePrivileges {
  id: string;
  priviliges: IPermission[];
}

export interface INodeExportAuth {
  id: string;
  isExportEnabled: boolean;
}

export enum INodeMetadataKeys {
  PrimaryContactName,
  PrimaryContactEmail,
  Telephone,
  Address,
  CustomerSiteId,
  Longitude,
  Latitude,
  TimeZone,
  CommissioningStatus
}

interface IUserStatus {
  type: string;
  dateTime: string;
}

export interface IOrganisationUsers {
  id: string;
  roles: IRole[];
  displayName: string;
  lastName: string;
  firstName: string;
  email: string;
  phone: string;
  registrationStatus: IUserStatus;
  role?: string;
  status?: string;
  userSettings?: Array<any>;
  userWorkgroups?: Array<any>;
}
// ↑ this and ↓ this should be the same type, join when this the case from Organisation vs User APIs
export interface IUser {
  userSettings?: Array<any>;
  userWorkgroups?: Array<any>;
  firstName: string;
  lastName: string;
  phone?: string;
  email: string;
  id: string;
  roles?: IRole[];
}

export interface IAddressMatadata {
  name: string;
  value: string;
}

export interface IOrganisation {
  childCount: number;
  externalId: string;
  id: string;
  logoUri: string | null;
  name: string;
  type: string;
  zuoraAccountNo: string;
  orgType: string | null | undefined;
  addressMetadata: IAddressMatadata[];
  actions?: Array<any>;
  servedBy?: string;
}

export interface IOrganisationSiteAndUserCount {
  nodeId: string;
  userCount: number;
  siteCount: number;
}

export interface IOrganisationSiteAndUserCount2 {
  nodeId: string;
  totalSiteCount: number | string;
  registeredSitesCount: number | string;
  type: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  status: string;
}

export interface INode {
  id: string;
  name: string;
  logoUri: string;
  type: string;
  externalId: string;
  parentId: string;
  childCount: number;
  metadata: Array<INodeMetadata>;
  childNodes: Array<INode>;
  privileges: Array<string>;
  subscriptionDetails: ISubscriptionDetails;
}

export interface ISubscriptionDetails {
  id: string;
  resourceGroupId: string;
  bundleId: string;
  bundle: IBundle;
  subscriptionNumber: string;
  orderNumber: string;
  createdOn: Date;
  activatedOn: Date;
  validTo: Date;
  additionalInfo: string;
}

// API Response interfaces
export interface IRoleResponse extends ICollectionResponse<IRole[]> { }

export interface IUserResponse extends ICollectionResponse<IUser[]> { }

export interface INodeResponse extends ICollectionResponse<INode[]> { }

export interface IBundleResponse extends ICollectionResponse<IBundle[]> { }

export interface IOrganisationUserResponse
  extends ICollectionResponse<IOrganisationUsers[]> { }

export interface IOrganisationResponse
  extends ICollectionResponse<IOrganisation[]> { }
export interface IOrganisationSiteAndUserCountResponse
  extends ICollectionResponse<IOrganisationSiteAndUserCount[]> { }

interface ICommandPatternResponse {
  errors: any;
  response: any;
  status: string;
  statusCode: number;
}

export interface IUserActivationResponse {
  id: string;
  output: ICommandPatternResponse;
}

export enum EModalOperations {
  CREATE,
  READ,
  UPDATE
}

export interface ICreateNewNodeResponse {
  authorizations: any;
  childCount: number;
  childNodes: [];
  externalId?: string;
  id: string;
  logoUri?: string;
  metadata?: any;
  name: string;
  parent?: any;
  parentId?: string;
  type: string;
}
export interface IHierarchyBuilderNodeData {
  name: string;
  id: string;
  rootNodeId: string;
  path: string[];
  [key: string]: any;
}

export enum OnBoardingStatus {
  UnderProvisioning = 'Under Provisioning',
  ProvisioningFailed = 'Provisioning Failed',
  ProvisioningCompleted = 'Provisioning Completed',
  Failed = 'Failed',
  Completed = 'Completed',
  InProgress = 'InProgress',
}


export interface IActivateSubscriptionPayload {
  action: string;
  subscriptionNumber: string;
  activationDate: string;
  organizationName: string | null;
  siteName: string;
  countryName: string | null;
  anniversaryDate: string | null;
  sector: string | null;
  isAnniversaryDateSkipped: boolean;
  billingCycle: string | null;
}